import React from 'react';
import styles from './GradeDisplay.module.css';

const GradeDisplay = ({ 
  grade, 
  gradeLevel = 'primary', 
  showDetails = false, 
  size = 'medium',
  interactive = false,
  onGradeClick = null 
}) => {
  if (!grade) return null;

  const handleClick = () => {
    if (interactive && onGradeClick) {
      onGradeClick(grade);
    }
  };

  const getSizeClass = () => {
    switch (size) {
      case 'small': return styles.small;
      case 'large': return styles.large;
      default: return styles.medium;
    }
  };

  const renderPrimaryGrade = () => {
    const { stars, emojiGrade, masteryLevel, feedback } = grade;
    
    return (
      <div 
        className={`${styles.primaryGrade} ${getSizeClass()} ${interactive ? styles.interactive : ''}`}
        onClick={handleClick}
      >
        <div className={styles.starsContainer}>
          {[...Array(5)].map((_, index) => (
            <span
              key={index}
              className={`${styles.star} ${
                index < stars ? styles.filled : styles.empty
              }`}
            >
              ⭐
            </span>
          ))}
        </div>
        
        <div className={styles.emojiGrade}>
          {emojiGrade}
        </div>
        
        {showDetails && (
          <div className={styles.details}>
            <div className={styles.masteryLevel}>
              {masteryLevel}
            </div>
            {feedback && (
              <div className={styles.feedback}>
                {feedback}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  const renderAcademicGrade = () => {
    const { letterGrade, percentage, gpa, feedback } = grade;
    
    return (
      <div 
        className={`${styles.academicGrade} ${getSizeClass()} ${interactive ? styles.interactive : ''}`}
        onClick={handleClick}
      >
        <div className={styles.letterGrade}>
          {letterGrade}
        </div>
        
        {showDetails && (
          <div className={styles.details}>
            {percentage !== null && (
              <div className={styles.percentage}>
                {percentage}%
              </div>
            )}
            {gpa !== null && (
              <div className={styles.gpa}>
                GPA: {gpa.toFixed(2)}
              </div>
            )}
            {feedback && (
              <div className={styles.feedback}>
                {feedback}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={styles.gradeDisplay}>
      {gradeLevel === 'primary' ? renderPrimaryGrade() : renderAcademicGrade()}
    </div>
  );
};

export default GradeDisplay;
